import styled from 'styled-components';
import TripAdvisorIconSvg from './happyTripAdvisor.svg';

const HappyTripAdvisorIcon = styled(TripAdvisorIconSvg as JSX.Element)`
  width: ${props => props.width || '2.6rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || 'black'};
  margin: ${props => props.margin};
`;

export default HappyTripAdvisorIcon;
